"use client";

import { useState } from 'react';
import styles from './_hcp-crf.module.scss';
import CustomImage from '@/components/image';

const ToggleButton = ({ className = "", onClick, label }) => (
  <button
    className={`${styles.toggle} ${className}`}
    onClick={onClick}
    data-gtm-event-category="Toggle"
    data-gtm-event-action="Click"
    data-gtm-event-label={label}
  >
    <span className={`${styles.toggle_label} ${styles.toggle_label__moa}`}>Pharmacology</span>
    <span className={`${styles.toggle_label} ${styles.toggle_label__mod}`}>Pathophysiology</span>
  </button>
);

export default function HcpMoaCrf() {
  const [moaFigureText, setMoaFigureText] = useState("moa");
  const figuretoggle = () => {
    console.warn("figuretoggle");
    const moaFigure = document.getElementById('moaFigure');
    moaFigure.dataset.show = (moaFigure.dataset.show == "moa")? "mod" : "moa";
    setMoaFigureText(moaFigure.dataset.show);
  }
  return (
    <section className={styles.hcpmoacrf}>
      <div className={`container ${styles.container}`}>
    
        <div className={styles.info}>
          {moaFigureText == "moa" &&
            <div className={styles.moa}>
              <p>
                CRF has been identified as a primary regulator of the HPA axis, including production of adrenal cortisol, aldosterone, and androgens.<sup>2,3</sup>
              </p>
              <p>
                CRENESSITY is a potent and selective CRF<sub>1</sub> receptor antagonist.<sup>1,4,5</sup>&nbsp;<span className='text-hcp-eggplant font-semibold'>By selectively blocking CRF binding to CRF<sub>1</sub> receptors in the pituitary gland, CRENESSITY<sup>1</sup>:</span>
              </p>
              <ul>
                <li>Directly reduces the systemic surge of <strong className='text-hcp-eggplant'>ACTH</strong></li>
                <li>Reduces downstream production of <strong className='text-hcp-eggplant'>androgens</strong></li>
              </ul>
            </div>
          }

          {moaFigureText == "mod" &&
            <div className={styles.mod}>
              <p className='text-hcp-charcoal'>Cortisol deficiency leads to<sup>2,3</sup>:</p>
              <ul className='text-hcp-charcoal'>
                <li>Loss of negative feedback in <strong>HPA</strong> axis</li>
                <li>Increase in <strong>CRF</strong> secretion</li>
                <li>Increase in <strong>CRF<sub>1</sub></strong> receptor activation</li>
                <li>Systemic surges and constant elevation of <strong>ACTH</strong></li>
                <li>Overproduction of <strong>adrenal androgens</strong></li>
              </ul>
            </div>
          }
        </div>



        <div
          id="moaFigure"
          className={styles.figure}
          data-show="moa">
          <ToggleButton
            className="tablet:!hidden !mb-8"
            onClick={figuretoggle}
            label={`${moaFigureText==='moa'? "Pharmacology" : "Pathophysiology"} Toggle`}
          />
          <CustomImage
            className={styles.moa_fig}
            src='/images/components/Pharmacology_Pathophysiology-Schematic.svg'
            width={589}
            height={446}
            alt='Schematic showing how CRENESSITY selectively blocks CRF binding to CRF₁, which, in turn, reduces ACTH and androgens'
          />
          <CustomImage
            className={styles.mod_fig}
            src='/images/components/hcp/Pharmacology_Pathophysiology-Schematic.svg'
            width={589}
            height={446}
            alt='Schematic showing how cortisol deficiency in CAH leads to androgen excess'
          />
          <ToggleButton
            className="!hidden tablet:!flex"
            onClick={figuretoggle}
            label={`${moaFigureText==='moa'? "Pharmacology" : "Pathophysiology"} Toggle`}
          />
        </div>
        <div className={styles.note}>
          <div className="hcp-callout">
            CRENESSITY improves androgen control and allows for GC dose reductions, enabling a transformational approach to managing CAH.<sup>1</sup>
          </div>
        </div>
      </div>
    </section>
  );
}